import { t } from 'localization'
import Image from 'shared/components/Image'
import { colors, fonts, media } from 'shared/lib'
import { sizes } from 'shared/lib/media'
import styled from 'styled-components'

const TP = 'shared.stores.components.FlightClubBrands'

const brands = [ 
  {
    name: 'Air Jordan',
    url: 'air-jordans',
    image: 'air-jordans',
  },
  {
    name: 'Nike',
    url: 'nike',
    image: 'nike',
  },
  {
    name: 'Adidas',
    url: 'adidas',
    image: 'adidas',
  },
  {
    name: 'Yeezy',
    url: 'adidas/adidas-yeezy',
    image: 'yeezy',
  },
]

const FlightClubBrands = () => {
  return (
    <Layout>
      <Wrapper>
        <Title>{t(`${TP}.brands`, 'Brands')}</Title>
        <Body>
        {
          brands.map((brand, index) => {
            return ( 
              <BrandLink key={brand.name} href={`/${brand.url}`}>
                <div>
                  <ImageContainer>
                    <StyledImage $index={index}
                      src={`/static/staticPages/store-brand-${brand.image}.png`}
                      alt="Flight Club Stores"
                      sizes={`(min-width: ${sizes.medium}px) 500px, 100vw`}
                    />
                  </ImageContainer>
                  <BrandName>{brand.name}</BrandName>
                </div>
              </BrandLink>
            )
          })
        }
        </Body>
      </Wrapper>
    </Layout>
  )
}

const Layout = styled.div`
  background-color: ${colors.FC2_OFF_WHITE};
  display: grid
`

const Wrapper = styled.div`
  height: 100%;
  padding: 80px 20px 40px;
  ${media.large`
    padding: 80px 100px 50px;
    place-self: center;
    width: 100%;
  `}
  ${media.extraLarge`
    padding: 80px 150px 50px;
    max-width: 1500px;
    place-self: center;
    width: 100%;
  `}
`

const Body = styled.div`
  display: grid;
  grid-gap: 18px;
  grid-template-columns: 1fr 1fr;
  ${media.large`
    grid-gap: 18px;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 20px;
  `}
  ${media.extraLarge`
    grid-gap: 20px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    margin-bottom: 20px;
  `}
  margin-bottom: 40px;
`

const ImageContainer = styled.div`
  position: relative;
  object-fit: contain;
  max-height: 390px;
  height: 192px;
  width: 152px;
  ${media.medium`
    width: 307px;
    height: 390px;
  `}
  ${media.large`
    width: 240px;
    height: 297px;
  `}
`

const StyledImage = styled(Image)`
  object-fit: cover;
`

const Title = styled.h2`
  ${fonts.SUBTITLE_2}
  font-weight: 500;
  margin-top: 0;
  text-align: center;
  margin-bottom: 40px;
  font-size: 14px;
  line-height: 17px;
`

const BrandName = styled.p`
  ${fonts.SUBTITLE_3}
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0.15px;
  margin-top: 10px;
  text-align: center;
`

const BrandLink = styled.a`
  color: ${colors.FC2_BLACK};
  cursor: pointer;
  text-decoration: none;
  justify-self: center;
`

export default FlightClubBrands